(() => {
  const mainSection = document.querySelector('[id^="MainProduct-"]');
  if (!mainSection) return;

  /* ---------------------------------------------------------------
     Elegant "updated" pulse when Dawn's AJAX variant fetch replaces
     the price / inventory / sku containers.
     --------------------------------------------------------------- */
  function initVariantPulse() {
    const watchTargets = [
      mainSection.querySelector('[id^="price-"]'),
      mainSection.querySelector('[id^="Inventory-"]'),
      mainSection.querySelector('[id^="Sku-"]'),
    ].filter(Boolean);

    if (!watchTargets.length) return;

    watchTargets.forEach((el) => {
      const observer = new MutationObserver(() => {
        el.classList.remove('pdp-updated');
        // Force reflow so the animation can restart on rapid variant changes.
        void el.offsetWidth;
        el.classList.add('pdp-updated');
      });
      observer.observe(el, { childList: true, subtree: true });
    });
  }

  /* ---------------------------------------------------------------
     Add to Cart: brief success pulse once Dawn's product-form.js
     publishes a successful cart update (or an error state).
     --------------------------------------------------------------- */
  function initAddToCartFeedback() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
      if (data.source !== 'product-form') return;
      const button = mainSection.querySelector('.product-form__submit');
      if (!button) return;
      button.classList.remove('pdp-add-success');
      void button.offsetWidth;
      button.classList.add('pdp-add-success');
      window.setTimeout(() => button.classList.remove('pdp-add-success'), 700);
    });
  }

  /* ---------------------------------------------------------------
     Sticky Add to Cart bar (mobile/tablet only). Mirrors the real
     button/price and simply clicks the real submit button so all
     AJAX add-to-cart logic, double-submit guards, and error handling
     stay owned by Dawn's product-form.js.
     --------------------------------------------------------------- */
  function initStickyAddToCart() {
    const realButton = mainSection.querySelector('.product-form__submit');
    const productForm = realButton && realButton.closest('product-form');
    if (!realButton || !productForm) return;

    const titleEl = mainSection.querySelector('.product__title h1');
    const priceContainerEl = mainSection.querySelector('[id^="price-"]');

    function getVisiblePriceText() {
      if (!priceContainerEl) return '';
      const candidates = priceContainerEl.querySelectorAll('.price-item--sale, .price-item--regular');
      for (const candidate of candidates) {
        if (candidate.offsetParent !== null) return candidate.textContent.trim();
      }
      return '';
    }

    const bar = document.createElement('div');
    bar.className = 'pdp-sticky-atc';
    bar.innerHTML = `
      <div class="pdp-sticky-atc__info">
        <span class="pdp-sticky-atc__title"></span>
        <span class="pdp-sticky-atc__price"></span>
      </div>
      <button type="button" class="pdp-sticky-atc__button button button--primary">
        <span></span>
      </button>
    `;
    document.body.appendChild(bar);

    const stickyTitle = bar.querySelector('.pdp-sticky-atc__title');
    const stickyPrice = bar.querySelector('.pdp-sticky-atc__price');
    const stickyButton = bar.querySelector('.pdp-sticky-atc__button');
    const stickyButtonLabel = stickyButton.querySelector('span');

    function syncBar() {
      if (titleEl) stickyTitle.textContent = titleEl.textContent.trim();
      stickyPrice.textContent = getVisiblePriceText();

      const realLabel = realButton.querySelector('span');
      stickyButtonLabel.textContent = realLabel ? realLabel.textContent.trim() : realButton.textContent.trim();

      const disabled = realButton.hasAttribute('disabled');
      stickyButton.disabled = disabled;
      stickyButton.setAttribute('aria-disabled', String(disabled));
    }

    syncBar();

    if (priceContainerEl) {
      new MutationObserver(syncBar).observe(priceContainerEl, { childList: true, subtree: true });
    }
    new MutationObserver(syncBar).observe(realButton, { attributes: true, attributeFilter: ['disabled'] });

    stickyButton.addEventListener('click', () => {
      if (stickyButton.disabled || realButton.getAttribute('aria-disabled') === 'true') return;
      realButton.click();
    });

    const mq = window.matchMedia('(min-width: 990px)');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (mq.matches) {
            bar.classList.remove('is-visible');
            return;
          }
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(realButton);

    const onViewportChange = () => {
      if (mq.matches) bar.classList.remove('is-visible');
    };
    mq.addEventListener ? mq.addEventListener('change', onViewportChange) : mq.addListener(onViewportChange);
  }

  function init() {
    initVariantPulse();
    initAddToCartFeedback();
    initStickyAddToCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
